import { render, staticRenderFns } from "./FDelegationList.vue?vue&type=template&id=7df53ee8&"
import script from "./FDelegationList.vue?vue&type=script&lang=js&"
export * from "./FDelegationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports